import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1 -1","key":"svg-0"}]]

const IconCircleLetterIFilled = createReactComponent('filled', 'circle-letter-i-filled', 'CircleLetterIFilled', __iconNode);

export default IconCircleLetterIFilled;